// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HourglassOutlinedSvg from "@fishx/icons-svg/es/asn/HourglassOutlined";
import FishxIcon from '../components/FishxIcon';

var HourglassOutlined = function HourglassOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HourglassOutlinedSvg
  }));
};

HourglassOutlined.displayName = 'HourglassOutlined';
export default React.forwardRef(HourglassOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HourglassOutlined.js
// module id = 2937
// module chunks = 0